export default __webpack_public_path__ + "static/media/companies.3af36dbd.svg";